import { render, staticRenderFns } from "./QuillEditor.vue?vue&type=template&id=8cbdf4fe&scoped=true"
import script from "./QuillEditor.vue?vue&type=script&lang=js"
export * from "./QuillEditor.vue?vue&type=script&lang=js"
import style0 from "./QuillEditor.vue?vue&type=style&index=0&id=8cbdf4fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbdf4fe",
  null
  
)

export default component.exports